var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.759,
    height: 18.758,
    viewBox: "0 0 18.759 18.758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9838",
    "data-name": "Group 9838",
    transform: "translate(552 -20239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-551 20241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded",
    transform: "translate(-1 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notification",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_-Round-_-Notification-_-live_tv",
    "data-name": "-Round-/-Notification-/-live_tv"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9837",
    "data-name": "Group 9837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,0H18.759V18.759H0Z",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_-Icon-Color",
    "data-name": "\\uD83D\\uDD39-Icon-Color",
    d: "M8.425,13.885,11.536,12.1a.785.785,0,0,0,0-1.36L8.425,8.961a.786.786,0,0,0-1.172.68V13.2A.787.787,0,0,0,8.425,13.885ZM16.632,5.17H10.7l2.3-2.3a.392.392,0,0,0-.555-.555L9.6,5.162,6.753,2.317a.392.392,0,0,0-.555.555l2.3,2.3H2.563A1.563,1.563,0,0,0,1,6.733v9.379a1.568,1.568,0,0,0,1.563,1.563H16.632A1.568,1.568,0,0,0,18.2,16.113V6.733A1.563,1.563,0,0,0,16.632,5.17Zm-.782,10.943H3.345a.784.784,0,0,1-.782-.782V7.515a.784.784,0,0,1,.782-.782H15.851a.784.784,0,0,1,.782.782v7.816A.784.784,0,0,1,15.851,16.113Z",
    transform: "translate(-0.218 -0.48)",
    fill: "#0077b6",
    fillRule: "evenodd"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Icons-2",
    "data-name": "Icons",
    transform: "translate(-569 20241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded-2",
    "data-name": "Rounded",
    transform: "translate(-1 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notification-2",
    "data-name": "Notification",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_-Round-_-Notification-_-live_tv-2",
    "data-name": "-Round-/-Notification-/-live_tv"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9837-2",
    "data-name": "Group 9837",
    transform: "translate(18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M0,0H18.759V18.759H0Z",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_-Icon-Color-2",
    "data-name": "\\uD83D\\uDD39-Icon-Color",
    d: "M8.425,13.885,11.536,12.1a.785.785,0,0,0,0-1.36L8.425,8.961a.786.786,0,0,0-1.172.68V13.2A.787.787,0,0,0,8.425,13.885Z",
    transform: "translate(-0.218 -0.48)",
    fill: "#db5f28",
    fillRule: "evenodd"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptions);
export default __webpack_public_path__ + "static/media/subscriptions.ec2f20095333934a48a1e6ae4d69442f.svg";
export { ForwardRef as ReactComponent };